import { Component } from '@angular/core';
import { WorkflowBaseDroppedField } from '../base-dropped-field.component';

@Component({
  selector: 'app-workflow-droppable-shared-qr-code-field',
  templateUrl: './shared-qr-code.component.html',
  styleUrls: ['../../droppable-field.component.scss']
})
export class WorkflowDroppableSharedQrCodeFieldComponent extends WorkflowBaseDroppedField {}
